export default {
  WELCOME_MESSAGE: 'Advanced HR 2.0 - Depósito Directo',
};



// WEBPACK FOOTER //
// ./src/i18n/es-us.js